<template>
  <div class="groupbuy">
    <el-card>
      <div class="menu-box">
        <h2>雷锋e站团购管理</h2>
        <div class="box-bd">
          <el-row :gutter="20">
            <el-col :span="3">
              <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">发起团购</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="success" @click="multipleApproval">批量通过</el-button>
            </el-col>
            <el-col :span="4">
              <el-input
                placeholder="请输入搜索内容"
                v-model="getInfo.info"
                clearable
                @clear="search"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            ref="multipleTable"
            @selection-change="handleChange"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
            :row-key="getRowKeys"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              :selectable="selectable"
            />
            <el-table-column prop="title" label="团购标题" min-width="150">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" min-width="150">
            </el-table-column>
            <el-table-column prop="leader_name" label="团长" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.leader_name">
                  <div>{{ scope.row.leader_name }}</div>
                  <div style="font-size: 12px; color: #999;">{{ scope.row.leader_phone }}</div>
                </div>
                <span v-else style="color: #ccc;">未指定</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="团购价格" width="120">
              <template slot-scope="scope">
                <span style="color: #f56c6c; font-weight: bold;">￥{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="original_price" label="原价" width="120">
              <template slot-scope="scope">
                <span style="text-decoration: line-through; color: #999;">￥{{ scope.row.original_price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="group_num" label="成团人数" width="100">
            </el-table-column>
            <el-table-column prop="join_num" label="已参团" width="100">
            </el-table-column>
            <el-table-column prop="start_date" label="开始时间" width="160">
              <template slot-scope="scope">
                {{ scope.row.start_date }}
              </template>
            </el-table-column>
            <el-table-column prop="end_date" label="结束时间" width="160">
              <template slot-scope="scope">
                {{ scope.row.end_date }}
              </template>
            </el-table-column>
            <el-table-column prop="status_text" label="审核状态" width="120">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 0" type="warning">未审核</el-tag>
                <el-tag v-else-if="scope.row.status === 1" type="success">审核通过</el-tag>
                <el-tag v-else-if="scope.row.status === 2" type="danger">审核拒绝</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="440">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="success"
                  icon="el-icon-check"
                  @click="pass(scope.row)"
                  >通过</el-button
                >
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="danger"
                  icon="el-icon-close"
                  @click="decline(scope.row)"
                  >拒绝</el-button
                >
                <el-button
                  v-if="scope.row.status !== 1"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  @click="openEditDialog(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  icon="el-icon-s-order"
                  @click="viewOrders(scope.row)"
                  >订单</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-search"
                  @click="openDetail(scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[30, 60, 100]"
            :pager-count="15"
            layout="total, sizes, prev, pager, next"
            :page-size="getInfo.page_num"
            background
            :total="exp.num"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 发起/编辑团购弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :before-close="handleDialogClose"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="groupBuyFormRef"
        :model="groupBuyForm"
        :rules="groupBuyRules"
        label-width="100px"
        class="groupbuy-form"
      >
        <el-form-item label="团购标题" prop="title">
          <el-input
            v-model="groupBuyForm.title"
            placeholder="请输入团购标题"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="goods_name">
          <el-input
            v-model="groupBuyForm.goods_name"
            placeholder="请输入商品名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="团长" prop="leader_id">
          <el-select
            v-model="groupBuyForm.leader_id"
            placeholder="请选择团长"
            filterable
            clearable
            style="width: 100%;"
            @change="onLeaderChange"
          >
            <el-option
              v-for="item in leaderList"
              :key="item.id"
              :label="item.name + '（' + item.phone + '）'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团购价格" prop="price">
          <el-input-number
            v-model="groupBuyForm.price"
            :min="0"
            :precision="2"
            :step="10"
            placeholder="请输入团购价格"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="原价" prop="original_price">
          <el-input-number
            v-model="groupBuyForm.original_price"
            :min="0"
            :precision="2"
            :step="10"
            placeholder="请输入原价"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="成团人数" prop="group_num">
          <el-input-number
            v-model="groupBuyForm.group_num"
            :min="1"
            :step="1"
            placeholder="请输入成团人数"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="活动时间" prop="dateRange">
          <el-date-picker
            v-model="groupBuyForm.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="团购描述" prop="desc">
          <el-input
            v-model="groupBuyForm.desc"
            type="textarea"
            :rows="4"
            placeholder="请输入团购描述"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="团购图片" prop="file">
          <el-upload
            action="#"
            list-type="picture-card"
            :limit="9"
            :file-list="groupBuyForm.fileList"
            :on-remove="handleUploadRemove"
            :before-upload="beforeUpload"
            :auto-upload="false"
            accept=".jpg,.png,.jpeg,.gif"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="el-upload__tip">可上传多张图片，支持 jpg/png/jpeg/gif，最多9张</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog
      title="团购详情"
      :before-close="handleClose"
      :visible.sync="detailDialogVisible"
      width="80%"
    >
      <el-descriptions :column="2" border>
        <el-descriptions-item label="团购标题">{{ detailInfo.title }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ detailInfo.goods_name }}</el-descriptions-item>
        <el-descriptions-item label="团长姓名">{{ detailInfo.leader_name || '未指定' }}</el-descriptions-item>
        <el-descriptions-item label="团长电话">{{ detailInfo.leader_phone || '未指定' }}</el-descriptions-item>
        <el-descriptions-item label="团购价格">￥{{ detailInfo.price }}</el-descriptions-item>
        <el-descriptions-item label="原价">￥{{ detailInfo.original_price }}</el-descriptions-item>
        <el-descriptions-item label="成团人数">{{ detailInfo.group_num }}</el-descriptions-item>
        <el-descriptions-item label="已参团">{{ detailInfo.join_num }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ detailInfo.start_date }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ detailInfo.end_date }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag v-if="detailInfo.status === 0" type="warning">未审核</el-tag>
          <el-tag v-else-if="detailInfo.status === 1" type="success">审核通过</el-tag>
          <el-tag v-else-if="detailInfo.status === 2" type="danger">审核拒绝</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="团购描述" :span="2">{{ detailInfo.desc }}</el-descriptions-item>
      </el-descriptions>

      <h3 style="margin: 20px 0 10px 0;">团购图片</h3>
      <div v-if="detailInfo.file && detailInfo.file.length > 0" style="display: flex; flex-wrap: wrap;">
        <el-image
          v-for="(file, index) in detailInfo.file"
          :key="index"
          :src="file"
          :preview-src-list="detailInfo.file"
          style="width: 150px; height: 150px; margin: 10px;"
        ></el-image>
      </div>
      <span v-else>无图片</span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGroupBuyList,
  getGroupBuyDetail,
  addGroupBuy,
  editGroupBuy,
  auditGroupBuyPass,
  auditGroupBuyReject,
  deleteGroupBuy,
  getLeaderList,
} from '@/api/zhiqing/leifeng_groupbuy'

export default {
  data() {
    const validatePrice = (rule, value, callback) => {
      if (this.groupBuyForm.original_price && value >= this.groupBuyForm.original_price) {
        callback(new Error('团购价格必须低于原价'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLoading: false,
      exp: {
        num: 0,
      },
      getInfo: {
        info: '',
        page_code: 1,
        page_num: 15,
      },
      // 团长列表
      leaderList: [],
      tableData: [],
      checkedItem: [],
      // 发起/编辑弹窗
      dialogVisible: false,
      dialogTitle: '发起团购',
      isEdit: false,
      groupBuyForm: {
        id: '',
        title: '',
        goods_name: '',
        leader_id: '',
        leader_name: '',
        leader_phone: '',
        price: 0,
        original_price: 0,
        group_num: 10,
        dateRange: [],
        start_date: '',
        end_date: '',
        desc: '',
        file: [],
        fileList: [],
      },
      groupBuyRules: {
        title: [{ required: true, message: '请输入团购标题', trigger: 'blur' }],
        goods_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        leader_id: [{ required: true, message: '请选择团长', trigger: 'change' }],
        price: [
          { required: true, message: '请输入团购价格', trigger: 'blur' },
          { validator: validatePrice, trigger: 'blur' },
        ],
        original_price: [{ required: true, message: '请输入原价', trigger: 'blur' }],
        group_num: [{ required: true, message: '请输入成团人数', trigger: 'blur' }],
        dateRange: [{ required: true, message: '请选择活动时间', trigger: 'change' }],
        desc: [{ required: true, message: '请输入团购描述', trigger: 'blur' }],
      },
      // 详情弹窗
      detailDialogVisible: false,
      detailInfo: {},
    }
  },
  methods: {
    getRowKeys(row) {
      return row.id
    },
    sizeChange(value) {
      this.getInfo.page_num = value
      this.fetchList()
    },
    pageChange(value) {
      this.getInfo.page_code = value
      this.fetchList()
    },
    search() {
      this.getInfo.page_code = 1
      this.fetchList()
    },
    handleChange(val) {
      this.checkedItem = val
    },
    selectable(row) {
      return row.status === 0
    },
    // ========== 列表 ==========
    async fetchList() {
      this.loading = true
      try {
        const { data: res } = await getGroupBuyList(this.getInfo)
        if (res.code === 200) {
          this.tableData = res.data.data || []
          this.exp.num = res.data.total || 0
        } else {
          this.tableData = []
          this.exp.num = 0
          this.$message.error(res.message || '查询失败')
        }
      } catch (error) {
        this.tableData = []
        this.exp.num = 0
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    // ========== 团长列表 ==========
    async fetchLeaderList() {
      try {
        const { data: res } = await getLeaderList({})
        if (res.code === 200) {
          this.leaderList = res.data.data || []
        }
      } catch (error) {
        // 网络错误时静默处理，不影响页面加载
      }
    },
    // ========== 发起团购 ==========
    resetGroupBuyForm() {
      this.groupBuyForm = {
        id: '',
        title: '',
        goods_name: '',
        leader_id: '',
        leader_name: '',
        leader_phone: '',
        price: 0,
        original_price: 0,
        group_num: 10,
        dateRange: [],
        start_date: '',
        end_date: '',
        desc: '',
        file: [],
        fileList: [],
      }
      if (this.$refs.groupBuyFormRef) {
        this.$refs.groupBuyFormRef.clearValidate()
      }
    },
    onLeaderChange(val) {
      if (val) {
        const leader = this.leaderList.find(item => item.id === val)
        if (leader) {
          this.groupBuyForm.leader_name = leader.name
          this.groupBuyForm.leader_phone = leader.phone
        }
      } else {
        this.groupBuyForm.leader_name = ''
        this.groupBuyForm.leader_phone = ''
      }
    },
    openAddDialog() {
      this.isEdit = false
      this.dialogTitle = '发起团购'
      this.resetGroupBuyForm()
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.isEdit = true
      this.dialogTitle = '编辑团购'
      this.resetGroupBuyForm()
      this.groupBuyForm.id = row.id
      this.groupBuyForm.title = row.title
      this.groupBuyForm.goods_name = row.goods_name
      this.groupBuyForm.leader_id = row.leader_id
      this.groupBuyForm.leader_name = row.leader_name
      this.groupBuyForm.leader_phone = row.leader_phone
      this.groupBuyForm.price = row.price
      this.groupBuyForm.original_price = row.original_price
      this.groupBuyForm.group_num = row.group_num
      this.groupBuyForm.desc = row.desc
      this.groupBuyForm.start_date = row.start_date
      this.groupBuyForm.end_date = row.end_date
      if (row.start_date && row.end_date) {
        this.groupBuyForm.dateRange = [row.start_date, row.end_date]
      }
      this.groupBuyForm.file = row.file || []
      this.groupBuyForm.fileList = (row.file || []).map((url, index) => ({
        name: 'image_' + index,
        url: url,
      }))
      this.dialogVisible = true
    },
    handleDialogClose() {
      this.$refs.groupBuyFormRef.resetFields()
      this.dialogVisible = false
      this.resetGroupBuyForm()
    },
    handleUploadRemove(file, fileList) {
      const url = file.url
      const index = this.groupBuyForm.file.indexOf(url)
      if (index > -1) {
        this.groupBuyForm.file.splice(index, 1)
      }
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    async handleSubmit() {
      this.$refs.groupBuyFormRef.validate(async valid => {
        if (!valid) return
        if (this.groupBuyForm.price >= this.groupBuyForm.original_price) {
          this.$message.warning('团购价格必须低于原价')
          return
        }
        const [start_date, end_date] = this.groupBuyForm.dateRange || []
        const payload = {
          title: this.groupBuyForm.title,
          goods_name: this.groupBuyForm.goods_name,
          leader_id: this.groupBuyForm.leader_id,
          leader_name: this.groupBuyForm.leader_name,
          leader_phone: this.groupBuyForm.leader_phone,
          price: this.groupBuyForm.price,
          original_price: this.groupBuyForm.original_price,
          group_num: this.groupBuyForm.group_num,
          start_date: start_date,
          end_date: end_date,
          desc: this.groupBuyForm.desc,
          file: this.groupBuyForm.file,
        }
        this.submitLoading = true
        try {
          if (this.isEdit) {
            payload.id = this.groupBuyForm.id
            const { data: res } = await editGroupBuy(payload)
            if (res.code === 200) {
              this.$message.success('编辑成功')
              this.dialogVisible = false
              this.fetchList()
            } else {
              this.$message.error(res.message || '编辑失败')
            }
          } else {
            const { data: res } = await addGroupBuy(payload)
            if (res.code === 200) {
              this.$message.success('发起成功')
              this.dialogVisible = false
              this.fetchList()
            } else {
              this.$message.error(res.message || '发起失败')
            }
          }
        } catch (error) {
          this.$message.error('网络错误，请稍后重试')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // ========== 审核 ==========
    multipleApproval() {
      if (this.checkedItem.length === 0) {
        this.$message.warning('请选择需要通过的团购！')
        return
      }
      this.$confirm('确认批量通过团购?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(async () => {
          try {
            const ids = this.checkedItem.map(item => item.id)
            const { data: res } = await auditGroupBuyPass({ ids })
            if (res.code === 200) {
              this.$message.success(res.message || '审核通过成功！')
              this.$refs.multipleTable.clearSelection()
              this.fetchList()
            } else {
              this.$message.error(res.message || '审核失败')
            }
          } catch (error) {
            this.$message.error('网络错误，请稍后重试')
          }
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消操作' })
        })
    },
    pass(row) {
      this.$confirm('确认通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
      .then(async () => {
        try {
          const { data: res } = await auditGroupBuyPass({ id: row.id })
          if (res.code === 200) {
            this.$message.success('审核通过成功！')
            this.$refs.multipleTable.clearSelection()
            this.fetchList()
          } else {
            this.$message.error(res.message || '审核失败')
          }
        } catch (error) {
          this.$message.error('网络错误，请稍后重试')
        }
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消操作' })
      })
    },
    decline(row) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(async ({ value }) => {
        try {
          const { data: res } = await auditGroupBuyReject({ id: row.id, remark: value })
          if (res.code === 200) {
            this.$message.success('拒绝审核成功！')
            this.$refs.multipleTable.clearSelection()
            this.fetchList()
          } else {
            this.$message.error(res.message || '审核失败')
          }
        } catch (error) {
          this.$message.error('网络错误，请稍后重试')
        }
      })
      .catch(() => {
        this.$message({ type: 'info', message: '取消拒绝' })
      })
    },
    // ========== 查看团购订单 ==========
    viewOrders(row) {
      // 将团购信息保存到 sessionStorage,供订单页读取
      window.sessionStorage.setItem('groupbuy_order_info', JSON.stringify({
        id: row.id,
        title: row.title,
        goods_name: row.goods_name,
        leader_name: row.leader_name,
        leader_phone: row.leader_phone,
      }))
      this.$router.push({
        name: 'leifeng_groupbuy_order',
        params: { groupbuy_id: row.id },
      })
    },
    // ========== 详情 ==========
    async openDetail(row) {
      this.detailDialogVisible = true
      this.detailInfo = { ...row }
      try {
        const { data: res } = await getGroupBuyDetail({ id: row.id })
        if (res.code === 200) {
          this.detailInfo = res.data
        }
      } catch (error) {
        // 网络错误时使用列表行数据
      }
    },
    handleClose() {
      this.detailDialogVisible = false
      this.detailInfo = {}
    },
    // ========== 删除 ==========
    handleDelete(row) {
      this.$confirm(`确认删除团购「${row.title}」?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(async () => {
        try {
          const { data: res } = await deleteGroupBuy({ id: row.id })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.fetchList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        } catch (error) {
          this.$message.error('网络错误，请稍后重试')
        }
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
  },
  mounted() {
    this.fetchList()
    this.fetchLeaderList()
  },
}
</script>

<style scoped>
.groupbuy {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 120px);
}
.menu-box h2 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
}
.box-bd {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
.groupbuy-form {
  padding: 10px 0;
}
.dialog-footer {
  text-align: center;
}
</style>
